module.exports = __webpack_public_path__ + "media/images/Hisham-5943c16f7b0ba5695b754b679332a144.jpg";